// removed by extract-text-webpack-plugin
module.exports = {"tasks":"tasks-72fb8f","tasks__item":"tasks__item-3e822d","tasks__label":"tasks__label-2c08bf","tasks__title":"tasks__title-50ae8c","tasks__preview":"tasks__preview-3371c4","tasks__full":"tasks__full-2fca0a","tasks__close":"tasks__close-0d9590","glyphicon":"glyphicon-4d66ec","glyphicon-file":"glyphicon-file-557d14","glyphicon-download":"glyphicon-download-04cd22","progress-bar-stripes":"progress-bar-stripes-fe6bc8"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/tasks/style.pcss
// module id = ./src/blocks/tasks/style.pcss
// module chunks = 0